import { Link } from 'react-router-dom';
import { popularComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function PopularSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门<strong>漫画</strong>
            </h2>
            <p className="text-sm text-foreground-500">千万读者的共同选择</p>
          </div>
          <Link
            to="/category/xingji-manhua"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5" data-product-shop>
          {popularComics.slice(0, 8).map((comic, index) => (
            <div key={comic.id} className="relative">
              {index < 3 && (
                <div className="absolute -top-2 -left-2 z-10 w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-bold text-xs">
                  {index + 1}
                </div>
              )}
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}